// extracted by mini-css-extract-plugin
module.exports = {"buttonsArea":"profile-settings_buttonsArea__tvk-v","buttonSeparator":"profile-settings_buttonSeparator__2m6CN mr-2"};